const styles = (theme) => ({
  formContainer: {
    paddingTop: "0px",
    paddingBottom: "30px",
    width: "60ch",
    maxWidth: "100%",
    margin: "auto",
    textAlign: "center",
  },
  textfield: {
    "& .MuiOutlinedInput-root": {
      backgroundColor: "white",
      borderRadius: 12,
    },
    marginBottom: 32,
    width: "90%",
  },
  validateForm: {
    textDecoration: "none",
    color: "white",
    fontWeight: 600,
    marginTop: 20,
    marginBottom: 20,
    margin: theme.spacing(1),
    backgroundColor: theme.palette.orange.main,
    "&:hover": {
      backgroundColor: theme.palette.orange.dark,
    },
    "&.Mui-disabled": {
      backgroundColor: "rgba(255, 255, 255, 0.16)",
      color: "rgba(255, 255, 255, 0.7)",
    },
    "&:focus-visible": {
      outline: "2px solid #e8c635",
      outlineOffset: 2,
    },
  },
  acceptLink: {
    color: "#A9B8E8",
    textDecoration: "underline",
    "&:hover": {
      color: "#FFFFFF",
    },
  },
  passwordForgotten: {
    color: "#A9B8E8",
    marginTop: 12,
    textDecoration: "none",
    "&:hover": {
      color: "#FFFFFF",
      textDecoration: "underline",
    },
    "&:focus-visible": {
      outline: "2px solid #e8c635",
      outlineOffset: 2,
      borderRadius: 2,
    },
  },
  container: {
    padding: 30,
    borderRadius: 22,
    justifyContent: "center",
    display: "flex",
    alignItems: "center",
    width: 500,
    maxWidth: "90vw",
    color: "white",
  },
  appBar: {
    backgroundColor: theme.palette.darkGrey.main,
    paddingBottom: 24,
    paddingTop: 24,
  },
  card: {
    marginLeft: 32,
    height: 40,
    width: 40,
  },
  backgroundImg: {
    backgroundImage: `linear-gradient(rgba(255, 255, 255, 0.8), rgba(255, 255, 255, 0.8)), url('/background-login.png')`,
    backgroundSize: "cover",
    backgroundPosition: "center top",
    backgroundRepeat: "repeat-y",
    // height: "100vh",
  },
  signupForm: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    padding: "20px",
  },
  divider: {
    marginTop: 10,
    marginBottom: 10,
    width: "100%",
  },
  orLogin: {
    // width: "100%",
    paddingLeft: 6,
    paddingRight: 6,
    position: "absolute",
    // marginTop: -20,
    backgroundColor: theme.palette.primary.main,
  },
  facebookButton: {
    marginTop: 20,
    marginBottom: 10,
    textDecoration: "none",
    color: "#4654B9",
    borderColor: "#4654B9",
    fontWeight: 600,
    width: "75%",
    backgroundColor: "white",
    "&:hover": {
      backgroundColor: "#f0f0f0",
    },
  },
  googleButton: {
    marginTop: 20,
    textDecoration: "none",
    color: "#E32424",
    borderColor: "#E32424",
    width: "75%",
    fontWeight: 600,
    marginBottom: 10,
    backgroundColor: "white",
    "&:hover": {
      backgroundColor: "#f0f0f0",
    },
  },
});

export default styles;
